<template>
  <div class="UsersReports">
    <h1 class="text-center my-7">گزارشات کاربران</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-card class="mb-10">
          <div class="d-flex align-center justify-center py-5">
            <h4 class="ml-3">تعداد کل ثبت نامی در سامانه</h4>
            <h3>
              <number-component
                :number="usersCount"
                unit="نفر"
              ></number-component>
            </h3>
            <small class="mr-2">
              ( فعال نشده:
              <number-component
                :number="unactivedUsersCount"
                unit="نفر"
              ></number-component>
              )
            </small>
            <v-btn
              depressed
              outlined
              color="primary"
              class="mx-2"
              router
              :to="{ name: 'UsersLists' }"
            >
              مشاهده جزییات
            </v-btn>
          </div>
        </v-card>
        <h4 class="mb-5">گزارش تعداد کاربران بر اساس استان</h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="stateSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="stateHeaders"
              :items="states"
              :search="stateSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number-component :number="item.count"></number-component>
              </template>
              <template v-slot:[`item._id`]="{ item }">
                <v-btn
                  outlined
                  depressed
                  color="primary"
                  router
                  :to="{
                    name: 'UserStateReports',
                    params: { id: item._id }
                  }"
                >
                  مشاهده شرکت کنندگان در این استان به تفکیک شهرستان
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="500"
          class="mb-10"
          :options="stateChartOptions"
          :series="stateChartSeries"
        />
        <h4 class="mb-5">گزارش تعداد کاربران - 20 شهرستان برتر</h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="stateSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="cityHeaders"
              :items="cities"
              :search="citySearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number-component :number="item.count"></number-component>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="500"
          class="mb-10"
          :options="cityChartOptions"
          :series="cityChartSeries"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "../_Navigation.vue";

export default {
  name: "users-reports-component",
  components: {
    NavigationComponent
  },
  data() {
    return {
      loading: false,
      usersCount: 0,
      unactivedUsersCount: 0,
      stateHeaders: [
        { text: "استان", value: "name", align: "center" },
        { text: "تعداد شرکت کننده", value: "count", align: "center" },
        { text: "اقدامات", value: "_id", align: "center" }
      ],
      states: [],
      stateSearch: "",
      cityHeaders: [
        { text: "شهرستان", value: "name", align: "center" },
        { text: "استان", value: "state", align: "center" },
        { text: "تعداد شرکت کننده", value: "count", align: "center" }
      ],
      cities: [],
      citySearch: "",
      stateChartSeries: [
        {
          name: "تعداد شرکت کننده",
          data: []
        }
      ],
      cityChartSeries: [
        {
          name: "تعداد شرکت کننده",
          data: []
        }
      ],
      stateChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "تعداد شرکت کنندگان استانی",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        stroke: {
          curve: "straight"
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          type: "gradient",
          gradient: {
            colorStops: [
              {
                offset: 0,
                color: "#3CD1A2",
                opacity: 1
              },
              {
                offset: 100,
                color: "#FF5670",
                opacity: 1
              }
            ]
          }
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 130,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10
        }
      },
      cityChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "شهرستان‌های با بالاترین میزان شرکت‌کننده",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        stroke: {
          curve: "straight"
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          type: "gradient",
          gradient: {
            colorStops: [
              {
                offset: 0,
                color: "#3CD1A2",
                opacity: 1
              },
              {
                offset: 100,
                color: "#FF5670",
                opacity: 1
              }
            ]
          }
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 130,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10
        }
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.get("user/reportStateCity").then((res) => {
        const data = res.data;

        // states
        data.stateCount.forEach((element) => {
          this.stateChartSeries[0].data.push(element.count);
          this.stateChartOptions.xaxis.categories.push(element.name);
        });

        // cities
        data.cityCount.forEach((element) => {
          this.cityChartSeries[0].data.push(element.count);
          this.cityChartOptions.xaxis.categories.push(element.name);
        });

        this.usersCount = res.data.usersCount;
        this.unactivedUsersCount = res.data.unactivedUsersCount;
        this.states = data.stateCount;
        this.cities = data.cityCount;
        this.loading = false;
      });
    }
  }
};
</script>
<style>
.UsersReports .apexcharts-xaxis-texts-g {
  transform: translate(0, 90px);
}
.UsersReports .apexcharts-yaxis {
  transform: translate(-97%, 0);
}
@media only screen and (max-width: 600px) {
  .UsersReports .apexcharts-xaxis-texts-g {
    transform: translate(0, 90px);
  }
}
</style>
